module.exports = __webpack_public_path__ + "static/media/pilli.ea68f849.png";